import DISPATCH_TRACKING from "widgets/Onboarding/queries/dispatchTracking.gql";
import { useMutation } from "@apollo/client";
const useTracking = () => {
    const [dispatch] = useMutation(DISPATCH_TRACKING);
    const track = (event, identity, payload) => {
        const input = { event, identity, payload };
        dispatch({ variables: { input } });
    };
    return {
        track,
    };
};
export default useTracking;
